import { createRouter, createWebHistory } from 'vue-router';

import Category from '@/models/category'; // category model

import Login from '@/views/main/login';
import Register from '@/views/main/register';
import NotFound from '@/views/main/not-found';

import BooksView from '@/views/books/view';

import ShelvesList from '@/views/shelves/list';
import ShelvesView from '@/views/shelves/view';

const ACCESS_GUEST = 1;
const ACCESS_AUTH  = 2;
const ACCESS_ALL   = 3;

const routes = [
	{
		name: 'home',
		path: '/',
		redirect: {name: 'shelves-my'},
		meta: {
			access: ACCESS_ALL,
		}
	},
	{
		name: 'sign-in',
		path: '/sign-in',
		component: Login,
		meta: {
			access: ACCESS_GUEST,
		}
	},
	{
		name: 'sign-up',
		path: '/sign-up',
		component: Register,
		meta: {
			access: ACCESS_GUEST,
		}
	},
	{
		name: 'shelves-my',
		path: '/collection',
		component: ShelvesList,
		meta: {
			access: ACCESS_AUTH,
			category: Category.TYPE_HOME
		}
	},
	{
		name: 'shelves-shop',
		path: '/wanted',
		component: ShelvesList,
		meta: {
			access: ACCESS_AUTH,
			category: Category.TYPE_SHOP
		}
	},
	{
		name: 'book-view',
		path: '/shelf/:idShelf/book/:idBook',
		component: BooksView,
		meta: {
			access: ACCESS_AUTH,
		}
	},
	{
		name: 'shelf-view',
		path: '/shelf/:idShelf',
		component: ShelvesView,
		meta: {
			access: ACCESS_AUTH,
		}
	},
	{
		name: 'not-found',
		path: '/:pathMatch(.*)*',
		component: NotFound
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes
});

// проверка доступа к странице
router.beforeEach((to, from, next) => {
	let userIsAuth = false;

	try {
		const user = JSON.parse(localStorage.getItem('user'));
		userIsAuth = !!(user && user.id);
	} catch (e) {
		userIsAuth = false;
	}

	// if isset access in metas
	if (to.meta && 'access' in to.meta) {

		if (to.meta.access === ACCESS_GUEST && userIsAuth) {
			return next({name: 'home'});
		}

		if (to.meta.access === ACCESS_AUTH && !userIsAuth) {
			return next({name: 'sign-in'});
		}

	}

	next();
});

export default router;